// === DEFAULT / CUSTOM STYLE ===
// WARNING! always comment out ONE of the two require() calls below.
// 1. use next line to activate CUSTOM STYLE (./src/themes)
// require(`./themes/app.${__THEME}.styl`)
// 2. or, use next line to activate DEFAULT QUASAR STYLE
require(`quasar-framework/dist/umd/quasar.mat.css`);

// ==============================
require(`../sass/project.scss`);

// Uncomment the following lines if you need IE11/Edge support
// require(`quasar/dist/quasar.ie`)
// require(`quasar/dist/quasar.ie.${__THEME}.css`)

import Vue from 'vue';

import Quasar, {Notify, Dialog} from 'quasar';
import 'quasar-extras/material-icons';
import lang from 'quasar-framework/i18n/ru';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';
import router from './router';
import store from './store';


Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = '/';
Vue.config.productionTip = false;
Vue.use(Vuelidate);

//Vue.prototype.$axios = axios
Vue.use(Quasar, {
  components: [

  ],
  plugins: [
    Notify,
    Vuelidate,
    Dialog
  ],
  i18n: lang
}); // Install Quasar Framework
//Vue.use(vueResource);

Vue.router = router;

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {url: 'oauth/token', method: 'POST', fetchUser: false},
  fetchData: {url: 'api/v1.0/user', method: 'GET', enabled: true},
  parseUserData: function (data) {
    return data;
  },
  rolesVar: 'role',
  authRedirect: {path: ''}
});
App.router = Vue.router;



/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js